  <template>
  <section class="bioCeo">
    <div class="photo">
        <img :src="data.photo.url" alt="">
        <h2>{{ data.title }}</h2>
    </div>

    <div class="text">
      <h2>{{ data.title }}</h2>
      <div v-html="data.bio"></div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps(['data'])
</script>

<style lang="scss" scoped>

.bioCeo:deep(){
  @apply main-container flex flex-col lg:flex-row  justify-center gap-8 md:gap-20 lg:gap-[118px] my-20 px-[10px] md:px-16 lg:px-0;
  .photo{
    @apply flex flex-col md:flex-row w-full gap-8  self-auto
    md:justify-between md:gap-0
    lg:w-1/3 lg:self-center;
    img {
        @apply rounded-[27px] w-full h-full
        md:max-w-[300px]
        lg:max-w-none
    }
    h2{
      @apply mt-[40px] leading-none block md:mt-0 lg:hidden text-2xl w-full md:text-3xl md:w-1/2 px-5 md:px-0 self-center;
    }
  }
  .text{
    @apply w-full lg:w-[51%] px-5 md:px-0 lg:flex lg:flex-col lg:justify-center;
    h2{
      @apply md:mt-0 text-[40px] leading-10 w-full mb-24 hidden lg:block;
    }
    div{
      @apply w-full columns-1 md:columns-2 gap-8
      xl:gap-[54px];
      p{

        @apply text-xl mb-5 ;
      }
    }
  }
}

</style>
